export default __webpack_public_path__ + "static/media/smartphone.75a7c6c5.webp";